export class affiliate_hold_time {
    public id: number;
    public name: string;
    public days: number;
    public hours: number;
    public minutes: number;
    public seconds: number;
}